var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconScmpLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 31,
  viewBox: "0 0 40 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 31V0H40V31H0ZM3.45071 27.5294H18.2664V3.46707H3.45071V27.5294ZM21.7336 27.5294H36.5493V3.46707H21.7336V27.5294Z",
  fill: "white"
})));
export default SvgIconScmpLogo;